// Detalle de licitaciones de un ejercicio + provincia (clic en el mapa).
import React, { useState, useEffect } from "react";
import axios from "axios";
import { X, MapPin, Loader2 } from "lucide-react";
import { API } from "@/context/AuthContext";

const fmtEuro = (v) => (v ? `${Math.round(v).toLocaleString("es-ES")} €` : "—");

export default function ProvinciaDetalleModal({ ejercicio, provincia, yearActual, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/historico/detalle`, { params: { ejercicio, provincia, year_actual: yearActual } })
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [ejercicio, provincia, yearActual]);

  const registros = data?.registros || [];

  return (
    <div className="fixed inset-0 bg-black/60 z-[60] flex items-start justify-center p-4 overflow-y-auto" onClick={onClose} data-testid="provincia-detalle-modal">
      <div className="bg-white rounded-xl max-w-2xl w-full my-8 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-gray-200 flex items-start justify-between sticky top-0 bg-white rounded-t-xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center shrink-0">
              <MapPin size={18} className="text-indigo-700" />
            </div>
            <div>
              <h3 className="text-sm font-bold text-gray-900">{provincia} · {ejercicio}</h3>
              <p className="text-xs text-gray-500 mt-0.5">{loading ? "Cargando…" : `${registros.length} licitación(es) registradas`}</p>
            </div>
          </div>
          <button onClick={onClose} data-testid="provincia-detalle-close" className="text-gray-400 hover:text-gray-600"><X size={18} /></button>
        </div>

        <div className="p-5">
          {loading ? (
            <div className="text-xs text-gray-400 py-10 text-center"><Loader2 className="animate-spin inline mr-2" size={14} />Cargando…</div>
          ) : registros.length === 0 ? (
            <div className="text-xs text-gray-500 py-10 text-center" data-testid="provincia-detalle-empty">
              No hay registros para {provincia} en {ejercicio}.
            </div>
          ) : (
            <div className="space-y-2 max-h-[60vh] overflow-y-auto" data-testid="provincia-detalle-list">
              {registros.map((r, i) => (
                <div key={i} className="border border-gray-100 rounded-lg p-2.5" data-testid={`provincia-detalle-row-${i}`}>
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <div className="text-[12px] font-semibold text-gray-800 truncate">{r.objeto || r.expediente || "—"}</div>
                      <div className="text-[10px] text-gray-400 mt-0.5 flex flex-wrap gap-x-2">
                        {r.expediente && <span>Exp. {r.expediente}</span>}
                        {r.direccion_general && <span>· {r.direccion_general}</span>}
                        {r.empresa_oferta && <span>· {r.empresa_oferta}</span>}
                        {r.estado && <span>· {r.estado}</span>}
                      </div>
                    </div>
                    <div className="text-[12px] font-bold text-[#007934] tabular-nums shrink-0">{fmtEuro(r.importe)}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
